import i18n from "i18next";
import moment from "moment";
import Plans from "views/Plans";
import Users from './views/Users';
import Panics from "views/Panics";
import Promos from './views/Promos';
import Banners from "views/Banners";
import AddMoney from "./views/AddMoney";
import CarsList from "./views/CarsList";
import Settings from './views/Settings';
import CarTypes from './views/CarTypes';
import AuthLoading from './AuthLoading';
import Withdraws from './views/Withdraws';
import Dashboard from './views/Dashboard';
import LoginPage from "./views/LoginPage";
import AllReports from "./views/AllReports";
import LocationView from "views/LocationView";
import ProtectedRoute from './ProtectedRoute';
import TermCondition from "views/TermCondition";
import { initReactI18next } from "react-i18next";
import PrivacyPolicy from "./views/PrivacyPolicy";
import Notifications from './views/Notifications';
import BookingHistory from './views/BookingHistory';
import { ThemeProvider } from '@mui/material/styles';
import { useThemeApp } from "components/Theme/theme";
import { MuiTheme } from "components/Theme/muiTheme";
import { useJsApiLoader } from '@react-google-maps/api';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { CssBaseline, GlobalStyles } from "@mui/material";
import CancellationReasons from './views/CancellationReasons';
import { AlertProvider } from "components/alert/AlertProvider";
import { BrowserRouter, Routes, Route } from 'react-router-dom'


const libraries = ['geometry', 'drawing', 'places'];


i18n
  .use(initReactI18next)
  .init({
    resources: {},
    fallbackLng: "en",
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
      escapeValue: false
    }
  });

function App() {
  const { colors } = useThemeApp();

  useJsApiLoader({
    id: 'google-map',
    libraries: libraries as any,
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY as any,
  })



  moment.locale('pt-br');

  moment.defaultFormat = 'DD/MM/YYYY';
  moment.defaultFormatUtc = 'DD/MM/YYYY';

  return (
    <GoogleOAuthProvider clientId={process.env.WEB_CLIENT_ID as any}>
      <ThemeProvider theme={MuiTheme(colors)}>
        <CssBaseline />
        <GlobalStyles styles={{}} />
        <AuthLoading>
          <AlertProvider>
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <Routes>
                <Route path="/promos" element={<ProtectedRoute permit={"admin"}><Promos /></ProtectedRoute>} />
                <Route path="/panics" element={<ProtectedRoute permit={"admin"}><Panics /></ProtectedRoute>} />
                <Route path="/settings" element={<ProtectedRoute permit={"admin"}><Settings /></ProtectedRoute>} />
                <Route path="/cartypes" element={<ProtectedRoute permit={"admin"}><CarTypes /></ProtectedRoute>} />
                <Route path="/withdraws" element={<ProtectedRoute permit={"admin"}><Withdraws /></ProtectedRoute>} />
                <Route path="/addtowallet" element={<ProtectedRoute permit={"admin"}><AddMoney /></ProtectedRoute>} />
                <Route path="/users" element={<ProtectedRoute permit={"admin,fleetadmin"}><Users /></ProtectedRoute>} />
                <Route path="/notifications" element={<ProtectedRoute permit={"admin"}><Notifications /></ProtectedRoute>} />
                <Route path="/dashboard" element={<ProtectedRoute permit={"admin,fleetadmin"}><Dashboard /></ProtectedRoute>} />
                <Route path="/cars" element={<ProtectedRoute permit={"admin,fleetadmin"}><CarsList /></ProtectedRoute>} />
                <Route path="/cancelreasons" element={<ProtectedRoute permit={"admin"}><CancellationReasons /></ProtectedRoute>} />
                <Route path="/bookings" element={<ProtectedRoute permit={"admin,fleetadmin"}><BookingHistory /></ProtectedRoute>} />
                {process.env.REACT_APP_PLANS === 'true' && <Route path="/plans" element={<ProtectedRoute permit={"admin"}><Plans /></ProtectedRoute>} />}
                {process.env.REACT_APP_BANNERS === 'true' && <Route path="/banners" element={<ProtectedRoute permit={"admin"}><Banners /></ProtectedRoute>} />}
                <Route path="/allreports/:fleetAdminId?/:fleetAdminName?" element={<ProtectedRoute permit={"admin,fleetadmin"}><AllReports /></ProtectedRoute>} />


                <Route path="/" element={<LoginPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/term-condition" element={<TermCondition />} />
                <Route path="/location/:shareId" element={<LocationView />} />
              </Routes>
            </BrowserRouter>
          </AlertProvider>
        </AuthLoading>
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
}

export default App;